import styled from 'styled-components'

export const StyledInput = styled.input`
  width: auto;
  height: auto;
  margin: 1.5rem 0 0 0;
  padding: 0.5rem;
  padding-left: 1rem;
  border: 1px solid #a2a2a2;
  border-radius: 34px;
  font-size: 1.275rem;
  color: #000000;

  ::placeholder {
    color: #a2a2a2;
  }
`
